// Cookie consent banner — wired to Shopify Customer Privacy API

(function () {
    var banner = document.getElementById('sh-cookie-banner');
    if (!banner) return;

    var CONSENT_KEY = 'shCookieConsent';
    var consent = window.localStorage.getItem(CONSENT_KEY);

    // If consent already recorded, sync to Shopify API and skip banner
    if (consent === 'accept' || consent === 'reject') {
        syncShopifyConsent(consent);
        window.shCookieConsent = consent;
        return;
    }

    // Show banner after brief delay for a quieter entrance
    setTimeout(function () {
        banner.removeAttribute('hidden');
    }, 1000);

    function syncShopifyConsent(value) {
        // Shopify Customer Privacy API — gates analytics, marketing, and sale-of-data
        if (window.Shopify && window.Shopify.customerPrivacy) {
            var granted = value === 'accept';
            window.Shopify.customerPrivacy.setTrackingConsent({
                analytics: granted,
                marketing: granted,
                preferences: granted,
                sale_of_data: false // Shardhouse does not sell data
            }, function () { });
        }
    }

    function setConsent(value) {
        window.localStorage.setItem(CONSENT_KEY, value);
        banner.style.opacity = '0';
        banner.style.transform = banner.style.transform.replace('translateY(0)', 'translateY(10px)');
        setTimeout(function () {
            banner.setAttribute('hidden', 'hidden');
        }, 300);

        window.shCookieConsent = value;
        syncShopifyConsent(value);
        document.dispatchEvent(new CustomEvent('cookie:consent', { detail: { consent: value } }));

        /* Advance house state when the visitor accepts */
        if (value === 'accept' && window.shHouse) {
            window.shHouse.advance('entered');
        }
    }

    banner.querySelector('.sh-cookie-accept')?.addEventListener('click', function (e) {
        e.preventDefault();
        setConsent('accept');
    });
    banner.querySelector('.sh-cookie-reject')?.addEventListener('click', function (e) {
        e.preventDefault();
        setConsent('reject');
    });
})();
